"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemRow = void 0;
var _mui = require("@ori-ui/mui");
var _CheckoutImage = _interopRequireWildcard(require("../CheckoutImage"));
var _Shade = require("./Shade");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ItemRow = ({
  className,
  itemCode,
  name,
  quantity,
  imageUrl,
  imageAlt,
  colorHex,
  colorName,
  colorUrl,
  price,
  totalPrice,
  totalBp,
  originalPrice,
  isSurpriseGift,
  isBundle = false
}) => {
  const imageSrc = isSurpriseGift ? _CheckoutImage.CheckoutSrcOptions.surprise : imageUrl;
  const priceOwnerState = {
    isOriginalPriceEmpty: !originalPrice
  };
  const ownerState = {
    isVisibleBundle: isBundle && !isSurpriseGift
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    ownerState: ownerState,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutImage.default, {
        src: imageSrc ?? _CheckoutImage.CheckoutSrcOptions.noImage,
        alt: imageAlt ?? name,
        width: "80px",
        height: "80px",
        background: _mui.theme.palette.grey[100]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailValues, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Detail, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductName, {
          variant: "body1",
          children: name
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SecondLine, {
          children: [isSurpriseGift ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            color: "textSecondary",
            variant: "body1",
            children: itemCode
          }), !isSurpriseGift && colorHex && colorName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shade.Shade, {
            colorHexCode: colorHex,
            colorName: colorName,
            colorImageSrc: colorUrl ?? ''
          }) : null]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Values, {
        children: [isSurpriseGift ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ItemPrice, {
          variant: "body1",
          children: price
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuantityInfo, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            variant: "body1",
            children: quantity
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DesktopWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PriceWrapper, {
            ownerState: priceOwnerState,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OriginalPrice, {
              variant: "body1",
              color: "GrayText",
              children: originalPrice
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TotalPrice, {
              variant: "body1",
              children: totalPrice
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TotalBp, {
            variant: "body1",
            children: totalBp
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MobileWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            variant: "body1",
            children: totalBp
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OriginalPrice, {
            variant: "body1",
            color: "GrayText",
            children: originalPrice
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TotalPrice, {
            variant: "body1",
            children: totalPrice
          })]
        })]
      })]
    })]
  });
};
exports.ItemRow = ItemRow;
